import PusherCommChannel from './PusherCommChannel';

/**
 * Get a Pusher client instance with proper authentication
 * @returns {Object} Configured Pusher client
 */
async function getPusherClient(store) {
  // Sometimes the pusher client is not initialized for some
  // reason, so init it.
  const client = store.getters['pusher/liveStreamChannelsClient'];
  return client;
}

/**
 * Factory class for creating comm channels
 */
export default class CommChannelFactory {
  /**
   * Create a comm channel instance based on type
   * @param {string} type - Type of comm channel (currently only 'pusher')
   * @param {Object} options - Configuration options
   * @returns {Object} Instance of the comm channel
   */
  static async create(type = 'pusher', options = {}) {
    const pusherClient = await getPusherClient(options.store);
    return new PusherCommChannel(pusherClient, options);
  }
}
